export default "__VITE_ASSET__Bl8TTmkN__"